import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { GerenciarPerfisUsuariosApiService } from '../../../services/gerenciar-perfis-usuarios-api.service';
import { MessageService } from '@services/message.service';
import { Usuario } from '../../../models/usuario';

@Component({
  selector: 'app-trocar-senha-usuario-dialog',
  standalone: false,
  templateUrl: './trocar-senha-usuario-dialog.component.html',
  styleUrl: './trocar-senha-usuario-dialog.component.scss',
})
export class TrocarSenhaUsuarioDialogComponent {

  usuario: Usuario;

  novaSenha = '';
  confirmacaoNovaSenha = '';
  salvando = false;

  constructor(
    private gerenciarPerfisUsuariosApiService: GerenciarPerfisUsuariosApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<TrocarSenhaUsuarioDialogComponent>,
  ) { }

  get senhasNaoConferem(): boolean {
    return !!this.confirmacaoNovaSenha && this.novaSenha !== this.confirmacaoNovaSenha;
  }

  public salvarClick(): void {
    if (!this.novaSenha?.trim()) {
      this.messageService.showToastWarning('Informe a nova senha do usuário.');
      return;
    }

    if (this.senhasNaoConferem) {
      this.messageService.showToastWarning('As senhas não conferem.');
      return;
    }

    this.salvando = true;
    this.gerenciarPerfisUsuariosApiService.trocarSenhaUsuario(this.usuario.id, this.novaSenha).subscribe({
      next: () => {
        this.messageService.showToastSuccess(`Senha de "${this.usuario.login}" alterada com sucesso.`);
        this.dialogRef.close(true);
      },
      error: () => {
        this.salvando = false;
      },
    });
  }
}
